export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13992.0cd0a004.jpg";